import { jwtDecode } from 'jwt-decode';

export default {
  isValidToken: function (token) {
    try {
      const header = jwtDecode(token, { header: true });
      const payload = jwtDecode(token);
      if (!header || !payload) return false;
      const { typ } = header || {};
      if (typ.toString().toLowerCase() !== 'jwt') return false;
      return true;
    } catch (error) {
      console.error('error decoding token', error);
      return false;
    }
  }
};
